import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "aria-live": "polite" }
const _hoisted_2 = ["innerHTML"]

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { YearlyMembershipFee } from '@src/view_models/MembershipFee';
import type { MembershipPaymentSummary } from '@src/Domain/Membership/MembershipPaymentSummary';

interface Props {
	paymentSummary: MembershipPaymentSummary;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MembershipSummaryHeadline',
  props: {
    paymentSummary: {}
  },
  setup(__props: any) {

const props = __props;
const { t, n } = useI18n();

const renderAmount = ( amount: number, interval: number, intervalTranslation: String ): string => {
	if ( interval === 12 ) {
		return '';
	}
	const formattedAmount = n( amount, { key: 'currency', currencyDisplay: 'name' } );
	return `(${formattedAmount} ${intervalTranslation})`;
};

const summaryData = computed( () => {
	const yearlyFee = new YearlyMembershipFee( props.paymentSummary.paymentIntervalInMonths, props.paymentSummary.membershipFee );
	return {
		paymentInterval: t( 'form_payment_interval_' + props.paymentSummary.paymentIntervalInMonths ),
		membershipType: t( props.paymentSummary.membershipType === 'active' ? 'membership_type_active' : 'membership_type_sustaining' ),
		membershipFeeFormatted: n( yearlyFee.membershipFeePerInterval, { key: 'currency', currencyDisplay: 'name' } ),
		membershipFeeYearlyFormatted: renderAmount(
			yearlyFee.yearlyFee,
			yearlyFee.paymentIntervalInMonths,
			t( 'form_payment_interval_12' )
		),
		paymentType: t( props.paymentSummary.paymentType ),
	};
} );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.$t( 'membership_form_summary_thanks_headline' )) + " ", 1),
    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("span", {
      innerHTML: _ctx.$t( 'membership_form_summary_headline', summaryData.value )
    }, null, 8, _hoisted_2)
  ]))
}
}

})